import { render } from "./rejectBooking.vue?vue&type=template&id=4c93ca48&scoped=true"
import script from "./rejectBooking.vue?vue&type=script&lang=js"
export * from "./rejectBooking.vue?vue&type=script&lang=js"

import "./rejectBooking.vue?vue&type=style&index=0&id=4c93ca48&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c93ca48"]])

export default __exports__